/* ==========================================================================
   DANG — Shop Page
   Sidebar category filter: show ONE category at a time.
   1. Clicking a sidebar link shows only that category, hides the other two.
   2. On load, the URL hash (#goggles / #shades / #accessories) picks the
      category — so the header + homepage links land on the right one.
      With no hash it leaves the first category (the default) showing.
   3. Color swatches still swap the card image in place (unchanged).
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var shopContainer = document.querySelector('[data-dang-shop]');
  if (!shopContainer) return;

  var navLinks = shopContainer.querySelectorAll('[data-shop-nav]');
  var sections = shopContainer.querySelectorAll('[data-shop-section]');

  /* --- 1. Show a single category, hide the rest --- */
  function showCategory(slug) {
    /* If the slug doesn't match a real section, fall back to the first one */
    var match = shopContainer.querySelector('[data-shop-section="' + slug + '"]');
    if (!match && sections.length > 0) {
      slug = sections[0].getAttribute('data-shop-section');
    }

    sections.forEach(function (section) {
      if (section.getAttribute('data-shop-section') === slug) {
        section.classList.add('dang-shop__collection--active');
      } else {
        section.classList.remove('dang-shop__collection--active');
      }
    });

    navLinks.forEach(function (link) {
      if (link.getAttribute('data-shop-nav') === slug) {
        link.classList.add('dang-shop__sidebar-link--active');
      } else {
        link.classList.remove('dang-shop__sidebar-link--active');
      }
    });
  }

  /* --- 2. Pick the category on load from the URL hash ---
     /pages/shop#shades (from the header or homepage links) opens Shades.
     No hash → keep the server-rendered first category showing. */
  function categoryFromHash() {
    return window.location.hash.replace('#', '');
  }

  var initialSlug = categoryFromHash();
  if (initialSlug) {
    showCategory(initialSlug);
  }

  /* Handle hash changes too — e.g. clicking a header category link while
     already on the Shop page. */
  window.addEventListener('hashchange', function () {
    showCategory(categoryFromHash());
  });

  /* --- 3. Sidebar clicks switch the visible category --- */
  navLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var slug = link.getAttribute('data-shop-nav');
      history.pushState(null, null, '#' + slug);
      showCategory(slug);
    });
  });

  /* --- 4. Per-card variant swatch preview/select + main-image hover ---
     Reuses the per-variant image data already rendered on each swatch:
       data-variant-image        = image 1 (featured) of that variant
       data-variant-hover-image  = image 2 (alt-tagged view), or '' if none
     Behavior:
       • Hover a swatch       → PREVIEW image 1 of that variant (no commit).
       • Leave the swatch row → revert to the SELECTED variant's image 1.
       • Click a swatch       → SELECT that variant (its image 1 = card image).
       • Hover the main image → show image 2 of the SELECTED variant, if any.
       • Selected variant with only one image → main-image hover does nothing. */
  var canHover = window.matchMedia('(hover: hover)').matches;
  var cards = shopContainer.querySelectorAll('.dang-shop__card');

  cards.forEach(function (card) {
    var primary = card.querySelector('.dang-shop__card-image--primary');
    if (!primary) return;
    var hoverImg = card.querySelector('.dang-shop__card-image--hover');
    var imageLink = primary.closest('.dang-shop__card-link');
    var swatchRow = card.querySelector('.dang-shop__swatches');
    var swatches = card.querySelectorAll('.dang-shop__swatch');
    var colorEl = card.querySelector('[data-card-color]');

    /* The currently SELECTED variant's two images + color name. Seed from the
       active swatch when there are swatches, else from what's already rendered
       (a product with a single variant has no swatches). */
    var activeSwatch = card.querySelector('.dang-shop__swatch--active') || swatches[0];
    var selectedImg1 = activeSwatch
      ? (activeSwatch.getAttribute('data-variant-image') || primary.getAttribute('src') || '')
      : (primary.getAttribute('src') || '');
    var selectedImg2 = activeSwatch
      ? (activeSwatch.getAttribute('data-variant-hover-image') || '')
      : (hoverImg ? (hoverImg.getAttribute('src') || '') : '');
    var selectedColor = activeSwatch ? (activeSwatch.getAttribute('data-variant-color') || '') : '';

    /* Color name shown inline with the title (en dash separator). Previews the
       hovered swatch's color, reverts to the selected color on mouse-out. */
    function setColor(c) {
      if (colorEl) colorEl.textContent = c ? ('– ' + c) : '';
    }

    /* Point the base image at a URL. Variant image-1 URLs are already cached
       (each swatch thumbnail uses the same URL), so the swap is instant. */
    function setPrimary(url) {
      if (!url) return;
      primary.src = url;
      primary.srcset = '';
    }

    /* Keep the image-2 overlay loaded with the selected variant's second image
       (so the main-image hover is instant), but hidden until that hover. */
    function syncHoverLayer() {
      if (!hoverImg) return;
      if (selectedImg2 && hoverImg.getAttribute('src') !== selectedImg2) {
        hoverImg.src = selectedImg2;
        hoverImg.srcset = '';
      }
      hoverImg.classList.remove('is-visible');
    }
    syncHoverLayer();

    /* The swatch the USER has actively clicked. Stays null on load even though
       one swatch is visually active by default — navigating requires a real
       user selection, so the first click on any swatch only SELECTS it. */
    var committedSwatch = null;

    /* Keep the card's links pointed at the selected variant, so clicking the
       main image (or title) opens the PDP on that variant (?variant=ID). */
    function updateCardLinks(url) {
      if (!url) return;
      card.querySelectorAll('.dang-shop__card-link').forEach(function (a) {
        a.setAttribute('href', url);
      });
    }
    if (activeSwatch) updateCardLinks(activeSwatch.getAttribute('data-product-url'));

    /* CLICK a swatch:
         • a not-yet-selected swatch → SELECT that variant (no navigation).
         • the already-selected swatch again → go to its PDP, variant pre-selected.
       (Clicking the main image / title navigates via the links kept in sync
        above — always to the currently selected variant.) */
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();

        if (swatch === committedSwatch) {
          var dest = swatch.getAttribute('data-product-url');
          if (dest) window.location.href = dest;
          return;
        }

        committedSwatch = swatch;
        var img1 = swatch.getAttribute('data-variant-image');
        if (img1) { selectedImg1 = img1; setPrimary(selectedImg1); }
        selectedImg2 = swatch.getAttribute('data-variant-hover-image') || '';
        selectedColor = swatch.getAttribute('data-variant-color') || selectedColor;
        setColor(selectedColor);
        syncHoverLayer();
        swatches.forEach(function (s) { s.classList.remove('dang-shop__swatch--active'); });
        swatch.classList.add('dang-shop__swatch--active');
        updateCardLinks(swatch.getAttribute('data-product-url'));
      });
    });

    /* Hover is pointer-only — on touch, a tap just fires the click above
       (select), and the main-image hover is irrelevant. */
    if (!canHover) return;

    /* HOVER a swatch → preview that variant's image 1 (no commit). */
    swatches.forEach(function (swatch) {
      swatch.addEventListener('mouseenter', function () {
        setColor(swatch.getAttribute('data-variant-color')); /* preview the hovered color name */
        var img1 = swatch.getAttribute('data-variant-image');
        if (!img1) return;
        if (hoverImg) hoverImg.classList.remove('is-visible'); /* never show image-2 while previewing */
        setPrimary(img1);
      });
    });

    /* Leave the whole swatch row → revert to the selected variant's image 1.
       (Listening on the row, not each swatch, so moving between swatches never
       flickers — the latest swatch's hover simply wins.) */
    if (swatchRow) {
      swatchRow.addEventListener('mouseleave', function () {
        setPrimary(selectedImg1);
        setColor(selectedColor);
      });
    }

    /* HOVER the main image → crossfade to image 2 of the SELECTED variant,
       only if it has one. */
    if (imageLink && hoverImg) {
      imageLink.addEventListener('mouseenter', function () {
        if (!selectedImg2) return;
        hoverImg.classList.add('is-visible');
      });
      imageLink.addEventListener('mouseleave', function () {
        hoverImg.classList.remove('is-visible');
      });
    }
  });
});
